import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CategoriasServico } from 'src/app/models/Servico.model';
import { CategoriaServicoService } from 'src/app/services/categoria-servico.service';

@Component({
  selector: 'app-lista-servicos',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.css'],
})
export class ListaServicosComponent implements OnInit, OnDestroy {
  categorias: Array<CategoriasServico> = [];
  categoriasSubscription: Subscription | undefined;

  imagemComunicado? = undefined; //'https://traefik.casan.com.br/static/imagens/site/comunicado-servicos.png';

  constructor(private categoriaService: CategoriaServicoService) {}

  desativarComunicado() {
    this.categoriaService.getVerificarComunicado().subscribe({
      next: (res) => {
        console.log(res);
      },
      error: (_err) => {
        this.imagemComunicado = undefined;
      },
    });
  }

  ngOnInit(): void {
    //this.desativarComunicado();

    this.categoriasSubscription = this.categoriaService
      .getAllCategorias()
      .subscribe((response: Array<CategoriasServico>) => {
        this.categorias = response;
      });
  }

  ngOnDestroy(): void {
    if (this.categoriasSubscription) {
      this.categoriasSubscription.unsubscribe();
    }
  }
}
